import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { Ticket as View } from './Ticket'

import {
  isPrexBusSelector
} from 'reduxModules/selectors/UserSelectors'
import { fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'

const mapStateToProps = createStructuredSelector({
  isPrexBus: isPrexBusSelector,
  fromCityTypeByLabel: fromCityTypeByLabelSelector,
})

export const Ticket = connect(mapStateToProps)(View)



// WEBPACK FOOTER //
// ./src/components/Ticket/index.js